import React, { Fragment, useEffect, useState } from "react";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { settingProjectsColumn } from "Constants/TableColumns";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getSettingProjects } from "Stores/actions/properties/ShopAction";
import { REGET, SETTINGSELECTEDPROJECT } from "Stores/actionTypes";
import { Radio } from "@material-ui/core";

export default function ListProjects({ nameSearch, doSearch, done }) {
  const dispatch = useDispatch();
  const { list, pagination, reget, taskId, selectedProject } = useSelector(
    (state) => ({
      list: state.shop.settingProjects_List,
      pagination: state.shop.settingProjects_Pagination,
      reget: state.shop.reget,
      taskId: state.shop.taskId,
      selectedProject: state.shop.selectedProject,
    })
  );
  const [sizePerPage, setSizePerPage] = useState(pagination.Limit);
  const [currentPage, setCurrentPage] = useState(pagination.Page);
  const [total, setTotal] = useState(pagination.Total);
  const [tblData, setTblData] = useState(list);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectRow, setSelectRow] = useState({
    mode: "radio",
    clickToSelect: false,
    onSelect: (row) => setSelectedRow(row),
    classes: "selection-row",
        selected: [selectedProject?.Id],
    selectionRenderer: ({ checked, disabled }) => {
      return (
        <Radio
          className="selectRadio"
          checked={checked}
          disabled={disabled}
          color="default"
        />
      );
    },
  });

  useEffect(() => {
    if (selectedRow) {
      dispatch({
        type: SETTINGSELECTEDPROJECT,
        project: selectedRow,
      });
    }
  }, [selectedRow]);

  useEffect(() => {
    if (selectedProject) {
      const selectRows = {
        mode: "radio",
        clickToSelect: false,
        onSelect: (row) => setSelectedRow(row),
        classes: "selection-row",
        selected: [selectedProject?.Id],
        selectionRenderer: ({ checked, disabled }) => {
          return (
            <Radio
              className="selectRadio"
              checked={checked}
              disabled={disabled}
              color="default"
            />
          );
        },
      };
      setSelectRow(selectRows);
    }
  }, [selectedProject]);

  useEffect(() => {
    (async () => {
      if (doSearch === "CLEARSEARCH") await getList();
      else if (doSearch === "DOSEARCH") {
        if (nameSearch !== 0) {
          await getList(1, sizePerPage, nameSearch);
          done();
        } else await getList();
      }
    })();
  }, [doSearch]);

  useEffect(() => {
    (async () => {
      if (reget && taskId === "SettingProject") {
        if (doSearch === "DOSEARCH") await getList(1, sizePerPage, nameSearch);
        else await getList();
        dispatch({
          type: REGET,
          status: false,
        });
      }
    })();
  }, [reget]);

  useEffect(() => {
    setTblData(list);
  }, [list]);

  useEffect(() => {
    setCurrentPage(pagination.Page);
    setSizePerPage(pagination.Limit);
    setTotal(pagination.Total);
  }, [pagination]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        await getList(page, sizePerPage);
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
  };

  const getList = async (
    Page = currentPage,
    Limit = sizePerPage,
    data = "NODATA"
  ) => {
    setLoading(true);
    try {
      let dataSearch = null;
      if (data !== "NODATA") {
        if (data !== "") dataSearch = { Name: data };
      } else if (nameSearch !== "")
        dataSearch = {
          Name: nameSearch,
        };
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        Limit,
        Page,
        ...dataSearch,
      };
      await dispatch(getSettingProjects(params));
    } catch (err) {
      console.error("[onGetGroupTemplates]", err);
    }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  return (
    <Fragment>
      <RemoteTable
        data={tblData}
        keyField="Id"
        selectRow={selectRow}
        columns={settingProjectsColumn}
        loading={loading}
        page={currentPage}
        sizePerPage={sizePerPage}
        totalSize={total}
        onTableChange={onTableChange}
      />
    </Fragment>
  );
}
